import React, { useState, useEffect } from "react"; 
import { NavLink, useNavigate } from "react-router";
import imgs from "../../../../../../assets/images/imgs";
import { Chip, Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { addCourseToCart } from "../../../../../../state/actions/addtoCartAction";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import CancelPopup from "../../../../../../components/CancelPopup/CancelPopup";
import { Modal } from "react-responsive-modal";
import './StudentSuggesionCourseData.css';
import { Tooltip } from "react-tooltip";
import { toTitleCase, hasFreeDomainAccess } from "../../../../../../utils/utlis";

const StudentSuggesionCourseData = ({ onNavigateAway, course, from, newStudFirstRender = false }) => {
  const { token } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [inCart, setInCart] = useState(course?.in_cart);
  const [item_id, setitem_id] = useState();
  const [showSkeleton, setShowSkeleton] = useState(false);

  // ── Image load gate ──────────────────────────────────────────────
  // Tracks whether the <img> src has fully downloaded.
  // Animation classes are applied ONLY after this flips to true so the
  // keyframe always plays against a visible image, not an empty slot.
  const [imgLoaded, setImgLoaded] = useState(false);

  const globalState = useSelector((state) => state.globalState);
  const currency_symbol = useSelector((state) => state?.globalState?.currency_symbol);
  const isMarketplace = globalState.enabled_modules?.includes('marketplace');

  // Students on a whitelisted email domain get the course free, so they skip
  // the cart entirely and follow the normal enroll/request flow.
  const isFreeForStudent = hasFreeDomainAccess(
    course,
    globalState?.email || globalState?.student_details?.data?.email,
  );

  // True only for AI-generated courses on first render — the only case
  // that gets the skeleton overlay + keyframe animation treatment.
  const isAnimatedCourse = course?.ai_course_generated && course?.student_top_course && newStudFirstRender;
  const shouldAnimate = imgLoaded && isAnimatedCourse;

  const getLabel = (status) => {
    switch (status) {
      case "Pending":  return "Request Sent";
      case "Active":   return "Go To Course";
      case "Complete": return "Go To Course";
      default:         return "View Course";
    }
  };

  function addToCartRequest() {
    setOpenDialog(!openDialog); 
  }

  const show = () => {
    setInCart(true);
    setOpenDialog(false);
    dispatch(addCourseToCart(item_id, token));
  };

  const close = (id) => {
    setitem_id(id);
    setOpenDialog(!openDialog);
  };

  const onCancel = (id) => {
    setitem_id(id);
    setOpenDialog(!openDialog);
  };

  const onConfirm = (item_id) => {
    setInCart(true);
    setOpenDialog(false);
    dispatch(addCourseToCart(item_id, token));
  };

  const getButton = (status, course_id) => {
    //  if (!globalState.subdomain_exists && globalState.enabled_modules?.includes('marketplace')) {
    if (
      !globalState.subdomain_exists &&
      globalState.enabled_modules?.includes('marketplace') &&
      !isFreeForStudent
    ) {
      return (
        <>
          {(course?.price === null && course?.discounted_price === null) ? (
            <button
              type="button"
              onClick={() => {
                navigate(`/course/${course_id}/view`, {
                  state: { course, isFromInvite: false, isFreeCourse: true, from },
                });
                if (typeof onNavigateAway === "function") onNavigateAway();
              }}
            >
              View Course
            </button>
          ) : (
            <>
              <button
                type="button"
                className="studentDashboar-profile-btn-folder-btn"
                onClick={() => {
                  navigate(`/course/${course_id}/view`, {
                    state: { course, isFromInvite: false, isFreeCourse: false, from },
                  });
                  if (typeof onNavigateAway === "function") onNavigateAway();
                }}
              >
                View Course
              </button>
              {inCart ? (
                <button type="button" onClick={() => navigate('/cart')}>
                  Go To Cart
                </button>
              ) : (
                <button
                  className={globalState.role === "Student" ? "block" : "hidden"}
                  type="button"
                  onClick={() => onConfirm(course_id)}
                >
                  <i className="fa-solid fa-cart-shopping" style={{ marginRight: "6px" }}></i>
                  Add To Cart
                </button>
              )}
            </>
          )}
        </>
      );
    } else {
      return (
        <button
          type="button"
          onClick={() => {
            if (status === "Active" || status === "Completed") {
              navigate(`/course/${course_id}`, { state: { course, from } });
            } else {
              navigate(`/course/${course_id}/view`, {
                state: { course, isFromInvite: false, from },
              });
            }
            if (typeof onNavigateAway === "function") onNavigateAway();
          }}
          disabled={status === "Pending"}
        >
          {getLabel(status)}
        </button>
      );
    }
  };

  const handleImageClick = () => {
    if (isMarketplace) {
      if (!globalState.subdomain_exists) {
        navigate(`/course/${course?.course_id}/view`, {
          state: { course, isFromInvite: false, from },
        });
      } else {
        if (course?.status === "Active" || course?.status === "Completed") {
          navigate(`/course/${course?.course_id}`, { state: { course, from } });
        } else {
          navigate(`/course/${course?.course_id}/view`, {
            state: { course, isFromInvite: false, from },
          });
        }
      }
    } else {
      if (course?.status === "Active" || course?.status === "Completed") {
          navigate(`/course/${course?.course_id}`, { state: { course, from } });
      } else {
          navigate(`/course/${course?.course_id}/view`, {
            state: { course, isFromInvite: false, from },
          });
      }
    }
    if (typeof onNavigateAway === "function") onNavigateAway();
  };

  const handleTitleClick = () => {
    if (!globalState.subdomain_exists) {
      navigate(`/course/${course?.course_id}/view`, {
        state: { course, isFromInvite: false, from },
      });
    } else {
      if (course?.status === "Active" || course?.status === "Completed") {
        navigate(`/course/${course?.course_id}`, { state: { course, from } });
      } else {
        navigate(`/course/${course?.course_id}/view`, {
          state: { course, isFromInvite: false, from },
        });
      }
    }
    if (typeof onNavigateAway === "function") onNavigateAway();
  };

  // ── Full card skeleton (shown during AI course first-render delay) ─
  const SkeletonCard = () => (
    <div className="studentDashboar-Suggested-Courses-folder">
      <Skeleton variant="rectangular" width="100%" height={160} sx={{ borderRadius: "10px", mb: 1.5 }} />
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
        <Skeleton variant="circular" width={36} height={36} />
        <div style={{ flex: 1 }}>
          <Skeleton variant="text" width="50%" height={16} />
          <Skeleton variant="text" width="30%" height={13} />
        </div>
      </div>
      <Skeleton variant="text" width="40%" height={13} sx={{ mb: 0.5 }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
        <Skeleton variant="text" width="60%" height={20} />
        <Skeleton variant="text" width="15%" height={20} />
      </div>
      <Skeleton variant="text" width="25%" height={20} sx={{ mb: 1 }} />
      <div style={{ display: "flex", gap: "8px" }}>
        <Skeleton variant="rounded" width="48%" height={36} />
        <Skeleton variant="rounded" width="48%" height={36} />
      </div>
    </div>
  );

  useEffect(() => {
    if (newStudFirstRender && course?.ai_course_generated && course?.student_top_course) {
      setShowSkeleton(true);
      setTimeout(() => setShowSkeleton(false), 8000);
    }
  }, [course, newStudFirstRender]);

  // Reset imgLoaded whenever the course image URL changes so a fresh
  // card (e.g. after a course list refresh) re-runs the animation.
  useEffect(() => {
    setImgLoaded(false);
  }, [course?.image_url]);

  if (showSkeleton) return <SkeletonCard />;

  return (
    <>
      <div className="studentDashboar-Suggested-Courses-folder relative">

        {course?.ai_course_generated && course?.student_top_course && (
          <div className="absolute inset-0 overflow-hidden rounded-[inherit] pointer-events-none z-[3]">
            <span className="course-card-ribbon">First Lesson FREE</span>
          </div>
        )}

        {/* ── Image container ─────────────────────────────────────── */}
        {/* position:relative lets the Skeleton overlay sit inside it  */}
        <div
          className="studentDashboar-Suggested-Courses-image"
          onClick={handleImageClick}
          style={{ position: "relative" }}
        >
          {/* Skeleton overlay — ONLY for ai_course_generated + newStudFirstRender.
              All other courses render their image directly with no overlay. */}
          {!imgLoaded && isAnimatedCourse && (
            <Skeleton
              variant="rectangular"
              sx={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
                borderRadius: "inherit",
                transform: "none",
              }}
            />
          )}

          <img
            className={shouldAnimate ? "course-reveal-img" : ""}
            src={course?.image_url || imgs.jpg.course_demo_image}
            alt="Course Image"
            style={{
              // Hide only for animated courses while downloading so the
              // container holds its height and the Skeleton fills the slot.
              // All other courses: image renders visibly as normal.
              visibility: (!imgLoaded && isAnimatedCourse) ? "hidden" : "visible",
            }}
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
          />
        </div>

        {/* ── Text content ────────────────────────────────────────── */}
        {/* course-text-reveal class (and its animation-delay: 0.65s)
            is applied only once imgLoaded is true, so the left→right
            reveal chains off the actual image load, not component mount. */}
        <div className={shouldAnimate ? "course-text-reveal" : ""}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <NavLink to={`/Teacher/${course?.teacher}`}>
              <div className="studentDashboar-Suggested-Courses-profile-folder">
                <div className="studentDashboar-Suggested-Courses-profile">
                  <div className="studentDashboar-profile-image">
                    <img src={course?.ai_avatar ?? imgs.png.tearcher_profile_image} alt="Teacher Image" />
                  </div>
                  <div className="studentDashboar-Suggested-Courses-profile-title">
                    <h2 className="tudentDashboar-profile-card-title">
                      {course?.teacher_name}
                      <p style={{ color: "#0D6EFD" }}>Teacher</p>
                    </h2>
                  </div>
                </div>
              </div>
            </NavLink>
            <div className="enroll-container"></div>
          </div>

          <div className="course-subject-suggested-course" style={{ color: "#898989" }}>
            <h5>
              {typeof course?.subject === 'string'
                ? toTitleCase(course.subject)
                : (course?.subject ? toTitleCase(Object.values(course.subject)[0]) : '')}
            </h5>
          </div>

          <div className="studentDashboard-course-name-rating">
            <h2
              className="studentDashboar-profile-course-title"
              onClick={handleTitleClick}
              {...(course?.name?.length > 20 && {
                "data-tooltip-id": "course-name",
                "data-tooltip-content": course?.name,
              })}
            >
              {course?.name?.length > 20 ? course.name.slice(0, 20) + "..." : course?.name}
            </h2>
            {globalState.enabled_modules?.includes('marketplace') && (
            <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                  <a> <i className="fa-solid fa-star"></i> </a>
                  <p className="rate">{course?.average_course_rating || "0"}</p>
                  <p className="number">({parseInt(course?.rating_count || 0)})</p>
            </div>
            )} 
      </div>
      
       {!globalState.subdomain_exists && globalState.enabled_modules?.includes('marketplace') && <div className="disscount-course-price-folder"
       style={{display:"flex",alignItems:"center",gap:"10px"}}>
        {course?.discounted_price != course?.price && <p style={{textDecoration:"line-through",color:"#898989"}} >{currency_symbol ?? ""}{course?.price ?? 0}</p>}
         <span className="course-price"  style={{  color:"#ee7139" ,font:"20px"}}>{currency_symbol ?? ""}{course?.discounted_price ?? 0}</span> 
        {/* <span className="course-price">
          ${course?.discounted_price != null ? 
          (Number.isInteger(course?.discounted_price) ? 
            course?.discounted_price : 
            course?.discounted_price.toFixed(2)) 
          : '0'}
        </span> */}
        {/* <span style={{  color: "#ee7139" ,font:"20px"}}> Hardcoded $50</span> */}
      </div>} 

      {/* {!globalState.subdomain_exists && <div className="disscount-course-price-folder">
        {course?.discounted_price != course?.price && course?.price > 0 && <p>${course?.price ?? 0}</p>}
         <span className="course-price">${course?.discounted_price ?? 0}</span> 
        <span className="course-price">
        {(course?.discounted_price != null && course?.discounted_price !== 0) ? 
          `$${Number.isInteger(course?.discounted_price) ? 
          course?.discounted_price : 
          course?.discounted_price.toFixed(2)}`  
        : 'Free'}
        </span>
      </div>} */}

          <div className="studentDashboar-profile-btn-folder">
            {getButton(course?.status, course?.course_id)}
          </div>
        </div>

      </div>

      <Tooltip id="course-name" place="top" type="light" effect="float" />
    </>
  );
};

export default StudentSuggesionCourseData;
